import React, { memo, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, createSearchParams } from 'react-router-dom';

import { FunctionButton } from '@pulse-web-ui/button-v2';

import { PASSWORD_RECOVERY, addTestAttribute } from '@shared/index';

interface PasswordRecoveryButtonProps {
  isCandidateAuth?: boolean;
}

export const PasswordRecoveryButton = memo(
  ({ isCandidateAuth }: PasswordRecoveryButtonProps) => {
    const { t } = useTranslation();

    const passwordRecoveryLink = useMemo(
      () => ({
        pathname: PASSWORD_RECOVERY,
        ...(isCandidateAuth && {
          search: createSearchParams({ isCandidateAuth: 'true' }).toString(),
        }),
      }),
      [isCandidateAuth]
    );

    return (
      <Link to={passwordRecoveryLink}>
        <FunctionButton {...addTestAttribute('login.button.passwordRecovery')}>
          {t('PASSWORD_RECOVERY_BUTTON:buttons.forgot-your-password')}
        </FunctionButton>
      </Link>
    );
  }
);
